/**
 * This code exist only because of the prerender. We had difficulties making prerender.io work correctly with cookies
 * For prerender, we don't rely on locale cookie. Instead, we read the locale from the URL and we fetch translations
 * Async. Check usage of these functions
 */
let isPrerender = false;

export function getIsPrerender(): boolean {
    return isPrerender;
}

export function setIsPrerender(value: boolean): void {
    isPrerender = value;
}
